<template>
	<div data-tour="segments">
		<div class="cs-note mb-2">
			Segmenti calcolati ogni notte su tutta la storia: quanto tempo fa è l'ultimo ordine (recenza), quanti ordini (frequenza) e quanto ha speso il cliente (spesa). Non dipendono dal periodo scelto
			sopra.
		</div>
		<v-row dense>
			<v-col v-for="s in segments" :key="s.id" cols="12" sm="6" lg="4" xl="3">
				<v-card outlined class="cs-card">
					<div class="d-flex align-center">
						<span class="cs-title">{{ s.label }}</span>
						<v-spacer />
						<v-menu offset-y left>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon small v-bind="attrs" title="Azioni" v-on="on"><v-icon small>mdi-dots-vertical</v-icon></v-btn>
							</template>
							<v-list dense>
								<v-list-item link :disabled="!s.customers" @click="$emit('list', s)">
									<v-list-item-icon><v-icon small>mdi-format-list-bulleted</v-icon></v-list-item-icon>
									<v-list-item-title>Vedi la lista</v-list-item-title>
								</v-list-item>
								<v-list-item link :disabled="!s.customers" @click="$emit('export', s)">
									<v-list-item-icon><v-icon small>mdi-arrow-collapse-down</v-icon></v-list-item-icon>
									<v-list-item-title>Esporta in Excel</v-list-item-title>
								</v-list-item>
								<v-list-item link :disabled="!s.reachable" @click="$emit('coupon', s)">
									<v-list-item-icon><v-icon small>mdi-ticket-percent-outline</v-icon></v-list-item-icon>
									<v-list-item-title>Crea coupon per il segmento</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</div>
					<div class="cs-desc">{{ s.description }}</div>
					<div class="cs-grid mt-2">
						<div class="cs-muted">Clienti</div>
						<div class="text-right font-weight-medium">{{ formatNumber(s.customers) }}</div>
						<div class="cs-muted">Spesa totale</div>
						<div class="text-right">{{ formatEurCents(s.spend) }}</div>
						<div class="cs-muted">Quota della spesa</div>
						<div class="text-right">{{ formatPct(s.share) }}</div>
						<div class="cs-muted">Ultimo ordine, in media</div>
						<div class="text-right">{{ s.avgRecency === null ? '—' : `${formatNumber(s.avgRecency)} giorni fa` }}</div>
						<div class="cs-muted">Con email del sito</div>
						<div class="text-right">{{ formatNumber(s.reachable) }}</div>
					</div>
					<div class="cs-action mt-2"><v-icon x-small>mdi-lightbulb-outline</v-icon> {{ s.action }}</div>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { formatEurCents, formatNumber, formatPct } from '../format';

export default {
	name: 'CustomersSegments',
	props: {
		segments: { type: Array, default: () => [] },
	},
	methods: { formatEurCents, formatNumber, formatPct },
};
</script>

<style scoped>
.cs-card {
	border-radius: 10px !important;
	padding: 12px 14px;
	height: 100%;
}
.cs-title {
	font-weight: 600;
	font-size: 15px;
}
.cs-desc,
.cs-note,
.cs-muted,
.cs-action {
	font-size: 12px;
	color: #5f6b7a;
}
.cs-grid {
	display: grid;
	grid-template-columns: 1fr auto;
	row-gap: 2px;
	column-gap: 12px;
	font-size: 14px;
}
</style>
